import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '../../Services/shared.service';
import { DialogeComponent } from '../dialoge/dialoge.component';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { PaginatorService } from '../../Services/PaginatorService';
import { Constant } from '../../Constants/constant';
import { LookupLocationComponent } from '../lookup-location/lookup-location.component';
import { JwtService } from '../../Services/jwt.service';
import { BaseComponent } from '../base/base.component';
import { MatPaginator } from '@angular/material/paginator';
import { ValidationService } from '../../Services/validation.service';
import { event } from 'jquery';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { Subject, firstValueFrom, of } from 'rxjs';
import { LoggingService } from '../../Services/NGLogger/logging-service.service';
import { debug } from 'console';

@Component({
  selector: 'app-lookup-business-unit',
  templateUrl: './lookup-business-unit.component.html',
  styleUrls: ['./lookup-business-unit.component.css']
})
export class LookupBusinessUnitComponent extends BaseComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginators!: MatPaginator;
  private locationInputSubject = new Subject<string>();
  BussinessUnit: any = [];
  SearchValue: string = "";
  TabIndex: number = 0;
  Operation: string = "Add Business Unit";
  LocationListData: any = [];
  filteredLocations: any[] = [];
  ManagerListData: any = [];
  filteredManagers: any[] = [];
  OnSearch: boolean = false;
  isNotSelect: boolean = false;
  renderer: any;
  IsLocationLoading: boolean = false;
  IsLocEnter: boolean = false;
  noDataLocations: boolean = false;
  override showloader: boolean = true;
  formGroup!: FormGroup;
  Submitted: any;
  constructor(
    public dialogRef: MatDialogRef<LookupBusinessUnitComponent>,
    private sharedService: SharedService,
    private Diloge: MatDialog,
    private jwtService: JwtService,
    private validationService: ValidationService,
    private loggingService: LoggingService,
    private fb: FormBuilder,
     @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { super(); if (this.dialogData.IsClientDetail) this.isNotSelect = true; }
  override ngOnInit(): void {
    this.formInit();
    this.formGroup.controls['EpId'].setValue(this.dialogData.EpId ?? null);
    this.LoadBusinessListData();
    this.LoadManagerListData();
    this.setupLocationSubscription();
    // this.LoadListData();
  }

  formInit() {
    this.formGroup = this.fb.group({
      id: [0],
      Name: ["", [Validators.required]],
      Description: ["", [Validators.required]],
      LocationId: ["", [Validators.required]],
      ManagerId: ["", [Validators.required]],
      DepartmentId: [""],
      CreatedBy: [0],
      CreatedOn: [""],
      isActive: [true],
      EpId: [this.dialogData?.EpId]
    });
  }

  onPopupClose() {
    this.dialogRef.close('popClose');
  }
  changeTab(event: any) {
    if (event.index == 0) {
      this.formGroup.patchValue({
        Name : "",
        Description : "",
        LocationId : null,
        isActive: true,
        epId: this.dialogData?.EpId
      });
      this.Operation = "Add Business Unit";
      this.noDataLocations = false;
    }
    else{
      this.filteredLocations = this.LocationListData.map((item: any) => ({
        id: item.id,
        locationName: item.locationName,
        locationInfo: this.formatLocationInfo(item),
      }));
    }
    this.Submitted = false;
    this.TabIndex = event.index;
  }

  gotoBack() {
    this.Operation = "Add Business Unit";
    this.TabIndex = 0;
  }

  clearSearchField() {
    this.SearchValue = "";
  }

  SelectBusinessUnit(data: any) {
    if (!this.isNotSelect)
      this.dialogRef.close(data);
  }

  clickMethod(item: any) {
    let jobid = item.jobId;
    const dialogRef = this.Diloge.open(DialogeComponent, {
      width: '30%',
      maxHeight: '90%',
      panelClass: 'modal-matdelete',
      data: { "title": "Warning!", "prefix":"Are you sure you want to delete ","message":  item.name + "?" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data.event == 'Yes') {
        this.DeleteBusinessUnit(item)
      }
    })
  }

  async Edit(data: any) {
    try {
      const res: any = await firstValueFrom(this.sharedService.GetBusinessUnitByID(data.id));

      if (res) {
        this.formGroup.patchValue({
          id: data.id,
          Name: res?.data?.name ?? "",
          Description: res?.data?.description ?? "",
          CreatedBy: res?.data?.createdBy ?? 0,
          CreatedOn: res?.data?.createdOn ?? "",
          isActive: res?.data?.isActive ?? true,
          DepartmentId: res?.data?.departmentId ?? "",
          EpId: this.dialogData?.EpId ?? 0
        });
        this.filteredManagers = [];
        this.filteredLocations = [];

        let location = data.location ? data.location.trim() : '';
        let locationInfo = data.locationInfo ? data.locationInfo.trim() : '';
        let combinedLocation = location ? `${location}${locationInfo ? ',' + locationInfo : ''}` : locationInfo;

        if (parseInt(res?.data?.managerId ?? 0) > 0) {
          this.filteredManagers.push({ id: data.managerId, fullName: data.managerName });
        }
        this.setFormControlValueNew('ManagerId', res.data?.managerId, this.filteredManagers);
        if (parseInt(res?.data?.locationId ?? 0) > 0) {
          this.filteredLocations.push({
            id: data.locationId,
            locationName: data.location,
            locationInfo: combinedLocation
          });
        }
        this.setFormControlValueNew('LocationId', res.data?.locationId, this.filteredLocations);
        this.Operation = "Update Business Unit";
        this.TabIndex = 1;
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  setFormControlValueNew(controlName: string, id: string | undefined, categoryList: any[]) {
    const item = categoryList.find((x: any) => x.id === Number(id));
    if (item) {
      this.formGroup.controls[controlName].setValue(item);
    }
  }

  async DeleteBusinessUnit(data: any) {
    try {
      const res: any = await firstValueFrom(this.sharedService.DeleteBusinessUnit(data.id));

      if (res) {
        if (res.succeeded) {
          this.showToastr(res?.messages[0]);
          this.LoadBusinessListData();
        } else {
          this.showToastr(res?.messages[0], 'error');
        }
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  async onSubmit() {
    this.Submitted = true;
    this.formGroup.patchValue({
      EpId: this.dialogData?.EpId ?? 0
    });
    const savValue = JSON.parse(JSON.stringify(this.formGroup.value));
    this.copyFormValues(this.formGroup, this.formGroup, [
      { sourceControlName: 'ManagerId', targetControlName: 'ManagerId', nestedKey: 'id' },
      { sourceControlName: 'LocationId', targetControlName: 'LocationId', nestedKey: 'id' }
    ]);
    if (this.formGroup.valid) {
      const locationId = this.formGroup.get('LocationId')?.value ?? 0;
      if (locationId > 0 && !this.noDataLocations) {
        try {
          const formData = this.formGroup.value;
          const res: any = await firstValueFrom(this.sharedService.addUpdateBusinessUnitCenter(formData));

          if (res) {
            if (res.succeeded) {
              this.showToastr(res?.messages[0]);
              this.formInit();
              this.LoadBusinessListData();
              this.handleUserViewing();
              this.TabIndex = 0;
              this.Submitted = false;           
            } else {
              this.formGroup.patchValue(savValue);
              const concatenatedMessage = res?.messages?.map((msg: any) => msg).join('\n');
              this.showToastr(concatenatedMessage, 'error');
            }
          }
        } catch (err) {
          this.loggingService.captureException(err);
        }
      }
    }
    else{
      this.formGroup.patchValue(savValue);
    }
  }

  async LoadBusinessListData() {
    const SerachData = this.SearchValue;
    this.dialogData.EpId = this.dialogData.EpId || 0;

    const searchVm = {
      search: SerachData,
      PageNumber: this.Paginator.PageIndex + 1,
      PageSize: this.Paginator.PageSize,
      EpId: this.dialogData.EpId,
    };

    try {
      const res: any = await firstValueFrom(this.sharedService.getBusinessUnitList(searchVm));

      if (res) {
        this.BussinessUnit = res?.data.items;
        this.Paginator.Length = this.BussinessUnit.length > 0 ? res?.data?.totalRecords : 0;

        if (this.OnSearch) {
          if (this.paginators) {
            this.paginators.pageIndex = 0;
          }
        }

        this.OnSearch = false;
        this.showloader = false;
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  paginationchanged(e: any) {
    this.LoadBusinessListData();
  }

  formatDate(date: any) {
    let newDate = Constant.formatDate(date);
    return this.sharedService.formatDate(newDate);
  }

  async LoadListData(): Promise<void> {
    const SearchData = this.SearchValue === "" ? " " : this.SearchValue;
    const searchVm = {
      Search: SearchData,
      PageSize: 0,
      PageNumber: 0,
      EpId: this.dialogData?.EpId,
    };

    try {
      const res: any = await firstValueFrom(this.sharedService.getEPLocationList(searchVm));

      if (res && res.data && res.data.items) {
        this.LocationListData = res.data.items;

        this.filteredLocations = this.LocationListData.map((item: any) => ({
          id: item.id,
          locationName: item.locationName,
          locationInfo: this.formatLocationInfo(item),
        }));
      }
    } catch (error) {
      this.loggingService.captureException(error);
    }
  }

  ngAfterViewInit(): void {
    const matOptions = document.querySelectorAll('.mat-option');
    matOptions.forEach((option: Element, index: number, options: NodeListOf<Element>) => {
      if (index < options.length - 1) {
        this.renderer.setStyle(option, 'border-bottom', '1px solid #ccc');
      }
    });
  }

  setupLocationSubscription() {
    this.locationInputSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(userInput => {
        const searchVm = {
          Search: userInput,
          PageSize: 0,
          PageNumber: 0,
          EpId: this.dialogData?.EpId
        };

        return this.sharedService.getEPLocationList(searchVm).pipe(
          map(res => ({ res, userInput })),
          tap(({ res, userInput }) => {
            if (res) {
              if(res?.data?.items?.length > 0){
                this.LocationListData = res?.data?.items;
                this.filteredLocations = this.LocationListData.map((item: any) => ({
                  id: item.id,
                  locationName: item.locationName,
                  locationInfo: this.formatLocationInfo(item),
                }));
                this.noDataLocations = this.filteredLocations.length === 0 && userInput.trim().length > 0;
                this.IsLocationLoading = false;
              }
              else{
                this.LocationListData = [];
                this.filteredLocations = [];
                this.IsLocationLoading = false;
              }
            }
          }),
          catchError(() => {
            this.filteredLocations = [];
            this.noDataLocations = true;
            this.IsLocationLoading = false;
            return of(null);
          })
        );
      })
    ).subscribe({
      error: (err) => this.loggingService.captureException(err),
    });
  }

  filterLocations(e: any) {
    this.IsLocEnter = true;
    this.IsLocationLoading = true;
    const userInput = e.target.value.toLowerCase();
    this.locationInputSubject.next(userInput);
    if (e.target.value === '') {
      this.formGroup.patchValue({ LocationId: null });
    }
  }

  onOptionSelectedL(event: any) {
    const selectedOption = this.filteredLocations.find(option => option.locationInfo === event.option.value);
    if (selectedOption) {
      this.formGroup.patchValue({
        LocationId: selectedOption.id,
        Location: selectedOption.locationInfo
      });
    }
  }


  async location_popup() {
    this.IsLocationLoading = true;
    const dialogRef = this.Diloge.open(LookupLocationComponent, {
      width: '90%',
      maxHeight: '90%',
      minHeight: '410px',
      panelClass: 'modal-matdelete',
      data: { EpId: this.dialogData?.EpId },
      disableClose: true,
    });

    try {
      const data = await firstValueFrom(dialogRef.afterClosed());

      await this.LoadListData();
      const selectedOption = this.filteredLocations.find(option => option.locationName === data?.locationName);

      if (selectedOption) {
        this.formGroup.patchValue({
          LocationId: selectedOption
        });
        this.noDataLocations = false;
      }
      this.IsLocationLoading = false;
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }


  OnBlankInput(e: any) {
    if (e.target.value == '' || e.target.value == null) {
      this.LoadBusinessListData();
    }
  }

  async LoadManagerListData() {
    const searchData = this.SearchValue.trim() ? this.SearchValue : " ";

    try {
      const res: any = await firstValueFrom(
        this.sharedService.getManagerList(searchData, this.dialogData.EpId, null, null)
      );

      if (res) {
        const managerList = res?.data.filter((item: any) => item.fullName && item.fullName.trim() !== '');
        this.ManagerListData = managerList;
        this.filteredManagers = managerList.map((item: any) => ({ id: item.id, fullName: item.fullName }));
      }

      const userType = this.getUserView(this.jwtService.getUserType());
      const isAdminViewingClient = this.Utype.Admin === this.jwtService.getUserType() && this.Utype.Client === userType;

      if (isAdminViewingClient) {
        this.handleAdminViewingClient();
      } else {
        this.handleUserViewing();
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  handleAdminViewingClient() {
    const selectedClientUserId = localStorage.getItem('selectedClientUserId') ?? '';
    const selectedOption = this.filteredManagers.find(option => option.id === Number(selectedClientUserId));

    if (selectedOption) {
      this.formGroup.patchValue({
        ManagerId: selectedOption
      });
    }
  }

  handleUserViewing() {
    const loginUserId = this.jwtService.getUserId();
    let selectedOption = this.filteredManagers.find(option => option.id === loginUserId);

    if (!selectedOption) {
      selectedOption = this.ManagerListData.find((option: any) => option.email === this.dialogData?.Email);
    }

    if (selectedOption) {
      this.formGroup.patchValue({
        ManagerId: selectedOption
      });
    }
  }

  onOptionSelectedManager(event: any) {
    const selectedOption = this.filteredManagers.find(option => option.id === event.option.id);

    if (selectedOption) {
      this.formGroup.patchValue({
        ManagerId: selectedOption
      });
    }
  }


  async filterManager(e: any) {
    const userInput = e.target.value.toLowerCase();
    try {
      const res: any = await firstValueFrom(
        this.sharedService.getManagerList(userInput, this.dialogData?.EpId, null, null)
      );

      if (res) {
        this.ManagerListData = res.data.filter((item: any) => item.fullName && item.fullName.trim() !== '');
        this.filteredManagers = this.ManagerListData.map((item: any) => ({ id: item.id, fullName: item.fullName }));
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }

    if (e.target.value === '') {
      this.formGroup.patchValue({ ManagerId: 0 });
    }
  }


  setPagination(e: any) {
    this.Paginator.PageSize = e.pageSize;
    this.Paginator.PageIndex = e.pageIndex;
    this.LoadBusinessListData();
  }

  onSearch() {
    this.OnSearch = true;
    this.Paginator.PageIndex = 0;
    this.showloader = true;
    this.LoadBusinessListData();
  }

  omitSpecialCharNumber(event: any) {
    this.validationService.omitSpecialCharNumber(event);
  }

  allowAlphaNumericHyphen(event: any) {
    this.validationService.allowAlphaNumericHyphen(event);
  }

  omitSpecialChar(event: KeyboardEvent): void {
    const isValid = this.validationService.omitValidateSpecialChar(event);
    if (!isValid) {
      event.preventDefault();
    }
  }

  removeSpaces(e: any) {
    this.validationService.removeSpaces(e);
  }

  omitValidateSpecialChar(event: any) {
    const isValid = this.validationService.omitValidateSpecialChar(event);
    if (!isValid) {
      event.preventDefault();
    }
  }

  onInputChange(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.value === '') {
      this.onSearch();
    }
  }

  clearInvalidFields(idField: string, nameField: string, filteredListName: string, originalListName: string) {
    this.sharedService.clearFieldsIfIdNotSelectedInObject(this.formGroup, idField, nameField);
    if (this.noDataLocations) {
      this.noDataLocations = false;
    }
  }

  handlePaste(event: ClipboardEvent,type: any): void {
    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text') || '';
    const sanitizedText = this.validationService.allowAlphaNumericHyphen(pastedText) as string;

    const target = event.target as HTMLInputElement;
    const start = target.selectionStart || 0;
    const end = target.selectionEnd || 0;
    target.value = target.value.slice(0, start) + sanitizedText + target.value.slice(end);
    target.setSelectionRange(start + sanitizedText.length, start + sanitizedText.length);
    if(type == 1){
      this.formGroup.patchValue({ Name:  target.value});
    }
  }

}

